import Vue from 'vue'
import Router from 'vue-router'

import config from 'SrcConfig'

// import store from '@/store'

// Layout
const Layout = () =>
    import ('@/components/layout')
    // const DefaultLayout = () => import('@/Layout/DefaultLayout')

// Views
const Dashboard = () =>
    import ('@/components/dashboard')
const Login = () =>
    import ('@/components/account/Login')
const BillPay = () =>
    import ('@/components/billpay')
const Register = () =>
    import ('@/components/account/Register')
const ForgotPassword = () =>
    import ('@/components/account/ForgotPassword')
const ResetPassword = () =>
    import ('@/components/account/ResetPassword')
const Page404 = () =>
    import ('@/components/shared/Page404')



import account from './account'
import todayOrders from "./todayOrders";
import historyOrders from "./historyOrders";
import support from "./support";
import specialEventOrders from "./specialEventOrders";
import general from "./settings/general";
import togo from "./settings/togo";
import delivery from "./settings/delivery";
import dinein from './settings/dinein'
import loyalty from './settings/loyalty'
import createOrder from './createOrder';
import businessProfile from './settings/businessProfile'
import menuBoard from './visuals/menuBoard'
import menuDisplay from './visuals/menuDisplay'
import myMenu from "./menueditor/myMenu";
import itemAvailabilities from "./menueditor/itemAvailability";
import menuModifier from "./menueditor/menuModifier";
import users from "./settings/users";
import serverShift from "./serverShift";
import endOfDay from "./endOfDay";
import overview from "./overview";
import tickets from './ticket'
import tipSummary from "./tipSummary";
import tutorial from "./tutorial";
import downloads from "./downloads";
import menuDisplays from "./menuDisplays";

Vue.use(Router)

const options = {
    mode: 'history',
    linkActiveClass: 'open active',
    // scrollBehavior: () => ({ y: 0 }),
    routes: [{
            name: 'root',
            path: '/',
            redirect: config.homeUrl,
            meta: { label: 'Home' },
            component: Layout,
            children: [{
                    name: 'login',
                    path: '/',
                    component: Login,
                    meta: { public: true },
            },
            {
                name: 'forgetPassword',
                path: 'forget-password',
                component: ForgotPassword,
                meta: { public: true },
                },
                {
                    name: 'resetPassword',
                    path: 'reset-password/:token',
                    component: ResetPassword,
                    props: true,
                    meta: { public: true },
                },
                {
                    name: 'dashboard',
                    path: 'dashboard',
                    component: Dashboard,
                    meta: { label: 'Dashboard', auth: [0, 1, 2, 3, 4, 5, 6, 7, 10] },
                },
                account,
                todayOrders,
                historyOrders,
                support,
                specialEventOrders,
                general,
                togo,
                delivery,
                createOrder,
                dinein,
                loyalty,
                businessProfile,
                menuBoard,
                menuDisplay,
                myMenu,
                itemAvailabilities,
                menuModifier,
                users,
                serverShift,
                endOfDay,
                overview,
                tickets,
                tipSummary,
                tutorial,
                downloads,
                menuDisplays
            ]
        },
        {
            name: 'catch-all',
            path: '*',
            component: Page404
        }
    ]
}

if (config.homeUrl == '/dashboard') {
    options.routes[0].children.push({
        name: 'dashboard',
        path: 'dashboard',
        meta: { label: 'Dashboard', auth: true },
        component: Dashboard
    })
}

if (config.auth.registerIsEnabled) {
    options.routes[0].children.push(...[{
        name: 'Register',
        path: 'register',
        component: Register,
        meta: { public: true }
    }])
}

if (config.auth.resetPasswordIsEnabled) {
    options.routes[0].children.push(...[{
            name: 'ForgotPassword',
            path: 'forgot-password',
            component: ForgotPassword,
            meta: { public: true }
        },
        {
            name: 'ResetPassword',
            path: 'reset-password',
            component: ResetPassword,
            meta: { public: true }
        }
    ])
}

export default new Router(options)
